import React from 'react';
import { useLocation } from '@tanstack/react-router';
import RuleSet from './RuleSet';

const Component = () => {
  const location = useLocation();
  const endOfURL = location.pathname.split('/').at(-1);
  const oneBeforeLast = location.pathname.split('/').at(-2);
  const mode = endOfURL === 'create' ? 'create' : oneBeforeLast !== 'set' ? 'edit' : undefined;
  return <RuleSet mode={mode} />;
};

export default Component;
